import { clsx } from 'clsx'

// Content-loading placeholder (prefer over spinners). Pulse honors reduced motion.
export function Skeleton({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={clsx(
        'block rounded-[var(--radius-sm)] bg-[var(--panel-2)] motion-safe:animate-pulse',
        className,
      )}
    />
  )
}
